var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{ref:"table",attrs:{"layers-filters":_vm.layersFilters,"is-custom-layer":true,"custom-layer-data":_vm.customLayerData,"has-edit-buttons":true},on:{"setLayerFeaturesFilters":_vm.setLayerFeaturesFilters,"deleteLayerFeaturesFilters":_vm.deleteLayerFeaturesFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }